import React, { useEffect, useState } from "react";

const Time = () => {
  const [nowTime, setNowTime] = useState("");

  // This function formats the time with leading zeros if necessary
  const formatTime = (timeUnit) =>
    timeUnit.toString().length === 1 ? "0" + timeUnit : timeUnit;

  useEffect(() => {
    const updateTime = () => {
      const today = new Date();
      const hours = formatTime(today.getHours());
      const minutes = formatTime(today.getMinutes());
      const seconds = formatTime(today.getSeconds());
      setNowTime(`${hours}:${minutes}:${seconds}`);
    };

    updateTime(); // Initial call to set the time immediately on mount
    const intervalTime = setInterval(updateTime, 1000);

    return () => clearInterval(intervalTime); // Cleanup interval on component unmount
  }, []);

  return (
    <main>
      <div>{nowTime}</div>
    </main>
  );
};

export default Time;
